import SelectController from "@/common/components/SelectController";
import { Mapper } from "@/common/services/mapper";
import { useFormContext, useWatch } from "react-hook-form";
import { useMaintenanceDirectiveDiagnosticEntryComplexities } from "../../../../hooks/directive/useMaintenanceDirectiveDiagnosticEntryComplexities";
import { DirectiveComplexityValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { useCreateForwardingsFormStore } from "../../../../stores/createForwardingsFormStore";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepAccordion from "../../../CreateForwardingDirectiveEntryFormStepAccordion";
import Button from "@/common/components/Button";

const DirectiveComplexityFormStepPending = ({
  state,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity>) => {
  const { increaseStep } = useCreateForwardingsFormStore();

  const {
    control,
  } = useFormContext<DirectiveComplexityValidationSchema>();

  const {
    complexity: watchComplexity,
  } = useWatch({
    control,
  });

  const {
    data: complexitiesOptions,
  } = useMaintenanceDirectiveDiagnosticEntryComplexities({
    mapper: Mapper.mapToOptions({
      valueFieldName: 'id',
      labelFieldName: 'display_name'
    }),
  });

  return (
    <CreateForwardingDirectiveEntryFormStepAccordion
      state={state}
      title="Complexidade do diagnóstico"
      body={(
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="complexity"
            options={complexitiesOptions}
            label="Complexidade do diagnóstico"
            placeholder="Defina a complexidade do diagnóstico"
            operationKlassToCheckPermission="Admin::Maintenance::Directive::DiagnosticEntryComplexities::Filter"
          />

          <div className="flex items-center justify-end">
            <div className="flex items-center gap-2">
              <Button
                disabled={!watchComplexity}
                onClick={increaseStep}
              >
                Confirmar
              </Button>
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default DirectiveComplexityFormStepPending;
